import { FormProvider, useForm } from "react-hook-form"
import useCheckoutContext, {
  useActiveStep,
  useMemorySheet,
  useStepByName
} from "../store"
import SubmitStepButton from "../user-details/submitStepButton"
import Details from "./details"
import Greetings from "./greetings"
import Motives from "./motives"
import PreviewSheet from "./previewSheet"

function MemorySheet() {
  const { setNextActiveStep, product } = useCheckoutContext()
  const step = useActiveStep()
  const { giftType } = useStepByName("deliveryMethod")

  const { memorySheet, setMemorySheet } = useMemorySheet()

  const methods = useForm({
    defaultValues: {
      firstName: memorySheet?.firstName,
      lastName: memorySheet?.lastName,
      greeting: memorySheet?.greeting,
      greetingHeadline: memorySheet?.greetingText,
      greetingText: memorySheet?.greetingText,
      funeralDate: memorySheet?.funeralDate,
      article: product.articles[0].ArticleId,
      motive: memorySheet?.motive.toString() || step.templates[0].id.toString(),
      selectedArticle: memorySheet?.selectedArticle,
      sender: memorySheet?.sender
    },
    mode: "onTouched"
  })

  const selectedMotive =
    methods.watch("motive") || memorySheet?.motive || step.templates[0].id

  const onSubmit = async (values) => {
    const template = step.templates.find(
      (template) => +template.id.toString() === +values.motive.toString()
    )

    values.articleInfo = product.articles.find(
      (article) => article.ArticleId == values.article
    )
    values.giftType = giftType
    values.template = template

    setMemorySheet(values)
    setNextActiveStep()
  }

  return (
    <>
      <FormProvider
        {...methods}
        selectedMotive={selectedMotive}
        giftType={giftType}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          {giftType === "memorialGift" && <Details giftType={giftType} />}

          <Motives />

          {giftType !== "memorialGift" && <Details giftType={giftType} />}

          <Greetings giftType={giftType} />
          <PreviewSheet />
          <SubmitStepButton />
        </form>
      </FormProvider>
    </>
  )
}

export default MemorySheet
